import { PayloadAction } from '@reduxjs/toolkit';
import { ENUM__redux_action } from '../_base/ENUM__redux_action';
import { StateWords } from './state_words';

export const local_words_set_word_for_adding_related = (value: string): PayloadAction<string> => ({
  type: ENUM__redux_action.WORDS_WITH_RELATED_WORDS_SET_WORD_FOR_ADDING_RELATED_WORDS,
  payload: value,
});

export const init_local_words_set_word_for_adding_related = (state: StateWords, action: PayloadAction<string>) => {
  state.word_english_for_adding_related_words = action.payload;
};
